/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterC = createReactComponent("outline", "letter-c", "IconLetterC", [["path", { "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5", "key": "svg-0" }]]);

export { IconLetterC as default };
//# sourceMappingURL=IconLetterC.mjs.map
